module.exports = __webpack_public_path__ + "img/number-icon.b7921cf8.svg";